// extracted by mini-css-extract-plugin
export default {"intro-video-container":"IntroVideo_intro-video-container__aLpuC","intro-video":"IntroVideo_intro-video__uHYKa"};